import { NavLink } from 'react-router-dom'
import { Sparkles } from 'lucide-react'
import { cn } from '@/lib/utils'
import { NAV_GROUPS } from './nav'
import { WorkspaceSwitcher } from './workspace-switcher'
import { UserMenu } from './user-menu'
import { Sheet, SheetContent } from '@/components/ui/sheet'

function NavList({ onNavigate }: { onNavigate?: () => void }) {
  return (
    <nav className="flex-1 space-y-4 overflow-y-auto px-3 py-2">
      {NAV_GROUPS.map((group) => (
        <div key={group.title} className="space-y-1">
          <p className="px-3 pb-1 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground/70">
            {group.title}
          </p>
          {group.items.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              onClick={onNavigate}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-xl px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-primary/10 text-primary'
                    : 'text-muted-foreground hover:bg-accent/60 hover:text-foreground',
                )
              }
            >
              <Icon className="h-[18px] w-[18px]" />
              {label}
            </NavLink>
          ))}
        </div>
      ))}
    </nav>
  )
}

function SidebarInner({ onNavigate }: { onNavigate?: () => void }) {
  return (
    <div className="flex h-full flex-col">
      <div className="flex items-center gap-2 px-4 py-4">
        <div
          className="flex h-9 w-9 items-center justify-center rounded-xl text-white ring-1 ring-[#d4af37]/40"
          style={{ background: 'linear-gradient(135deg, #012269, #1f3d99)' }}
        >
          <Sparkles className="h-5 w-5" />
        </div>
        <span className="text-base font-semibold tracking-tight">
          TEXA <span className="text-gold">HUB</span>
        </span>
      </div>
      <div className="px-3 pb-2">
        <WorkspaceSwitcher />
      </div>
      <NavList onNavigate={onNavigate} />
      <div className="border-t border-border/60 p-3">
        <UserMenu />
      </div>
    </div>
  )
}

export function Sidebar({
  mobileOpen,
  onMobileClose,
}: {
  mobileOpen: boolean
  onMobileClose: () => void
}) {
  return (
    <>
      {/* Desktop */}
      <aside className="hidden w-64 shrink-0 border-r border-border/60 bg-card/40 backdrop-blur-glass lg:block">
        <SidebarInner />
      </aside>

      {/* Mobile */}
      <Sheet open={mobileOpen} onOpenChange={(o) => !o && onMobileClose()}>
        <SheetContent side="left" className="w-72 p-0">
          <SidebarInner onNavigate={onMobileClose} />
        </SheetContent>
      </Sheet>
    </>
  )
}
